import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Decedat } from './decedati.interface';

@Injectable({
    providedIn: 'root'
})
export class DecedatiService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private getDecedatiListUrl = this.basePath + environment.interop.indoc.decedati.getDecedati;
    private getDecedatUrl = this.basePath + environment.interop.indoc.decedati.findDecedati;
    private storeDecedatiUrl = this.basePath + environment.interop.indoc.decedati.storeDecedati;
    private updateDecedatiUrl = this.basePath + environment.interop.indoc.decedati.updateDecedati;
    private deleteDecedatiUrl = this.basePath + environment.interop.indoc.decedati.deleteDecedati;

    constructor(private http: HttpClient) { }

    listDecedati() {
        return this.http.get(this.getDecedatiListUrl, this.httpOptions);
    }

    getDecedat(id: number) {
        return this.http.get(this.getDecedatUrl + id, this.httpOptions);
    }

    storeDecedati(data: Decedat) {
        return this.http.post(this.storeDecedatiUrl, data, this.httpOptions);
    }

    updateDecedati(data: Decedat, id: number) {
        return this.http.put(this.updateDecedatiUrl + id, data, this.httpOptions);
    }

    deleteDecedati(id: number) {
        return this.http.delete(this.deleteDecedatiUrl + id, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
